import { Separator } from 'components/Separator'
import { ComponentType } from 'react'
import { Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'
import { Agent } from './agent'
import { Badges } from './badges'
import { Details } from './details'
import { Extract } from './extract'
import { Description } from './description'
import { Extras } from './extras'
import { Gallery } from './gallery'
import { Map } from './map'
import { Places } from './places'
import { Tabs } from './tabs'

const Wrapper = styled.div`
  padding-bottom: 40px;
`

interface Props {
  property: any
  agent: any
  beforeOnShareClick: () => Promise<void>
  shareUrl:string
}

export const PropertyMobile: ComponentType<Props> = ({ property, agent, beforeOnShareClick, shareUrl }) => (
  <Wrapper>
    <Container>
      <Row>
        <Col>
          <Agent property={property} agent={agent} beforeOnShareClick={beforeOnShareClick} shareUrl={shareUrl} /> 
          <Gallery property={property} />
          <Badges property={property} />
          <Extract property={property} />
          <Separator />
          <Places property={property} />
          <Separator />
          <Details property={property} />
          <Separator />
          <Map property={property} />
          {property.comments && <Extras property={property} />}
          <Tabs property={property} />
          <Separator />
          <Description property={property} />
        </Col>
      </Row>
    </Container>
  </Wrapper>
)
